import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ADMIN_RESTRICTED_ROUTE, AUTH_LOGIN_ROUTE, authInterceptor, provideApiBaseUrl } from '@privaci/core';

import { routes } from './app.routes';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideApiBaseUrl(environment.apiUrl),
    // authInterceptor logs out and routes here on a 401; the staff sign-in lives at /login.
    { provide: AUTH_LOGIN_ROUTE, useValue: ['/login'] },
    // domainAdminGuard sends an authenticated non-admin here instead of the sign-in loop.
    { provide: ADMIN_RESTRICTED_ROUTE, useValue: ['/access-denied'] },
  ],
};
